import script from "./EditSlideDeckModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditSlideDeckModal.vue?vue&type=script&setup=true&lang=js"

import "./EditSlideDeckModal.vue?vue&type=style&index=0&id=61978820&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61978820"]])

export default __exports__